import React from "react";
import Page from "components/Page";
import starOutlineIcon from "../../../../assets/images/star-off.svg";
import deleteIcon from "../../../../assets/images/del.svg";
import addIcon from "../../../../assets/images/add_office.svg";
import styles from "../../../Ofiices/AddOffice/EditTabs.module.scss";
import accountPrefrencesStyles from "./../../accountpreferences.module.scss";
import { withTranslation } from "react-i18next";
import Card from "components/Card";
import Text from "components/Text";
import Input from "components/Input";
import NotAccessible from "accountOwner/pages/ManagerDashboard/components/NotAccessible";
import Loader from "components/Loader";
import usePolicyAcknowledgeTemplateHook from "./policyAcknowledgeTemplate.hooks";
import ToggleSwitch from "components/ToggleSwitch";
import SelectApprover from "./modals/SelectApprover";
import DeleteConfirmationModal from "components/DeleteConfirmationModal";

const PolicyAcknowledgementTemplate = ({ t, history }) => {
  const {
    ownerListLoading,
    staffList,
    staffListLoading,
    canAccessThisPage,
    getCommonAccessLoading,
    setStates,
    isStaff,
    states,
    policyDataLoading,
    onSubmitHandler,
    errors,
    approverErrors,
    formRef,
    submittingLoading,
    acknowledgementToggleOn,
    approverToggleOn,
    setApproverToggleOn,
    approvers,
    addApprover,
    updateApprover,
    deleteApprover,
    markAsDefault,
    showStaffSelectionModal,
    setShowStaffSelectionModal,
    openStaffSelectionModal,
    handleStaffSelection,
    confirmDeleteModal,
    confirmDeleteApprover,
    cancelDeleteApprover,
    handleEnablePolicyAcknowledgement,
    currentApproverId,
  } = usePolicyAcknowledgeTemplateHook(history);
  const goBack = () => history.goBack();

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setStates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Page
      onBack={() => {
        goBack();
      }}
      className={accountPrefrencesStyles["global-main-page"]}
      title={t("accountPreferences.policyAcknowledgementTemplate")}
    >
      {(getCommonAccessLoading ||
        ownerListLoading ||
        staffListLoading ||
        policyDataLoading ||
        submittingLoading) && <Loader />}
      {isStaff && states?.owner?.id && (
        <div className="show-owner-name-text marginBottom30">
            {t("accountPreferences.showingTemplates")}{" "}
            <span>
              '{states.owner.firstName} {states.owner.lastName}'
            </span>        
        </div>
      )}
      {canAccessThisPage ? (
        <>
          <form
            onSubmit={onSubmitHandler}
            className="w-100 form-wrapper"
            ref={formRef}
          >
            <Card
              className={
                accountPrefrencesStyles["form-width-controller"] +
                " p-0 shadow-none"
              }
            >
              <div
                className={accountPrefrencesStyles["new-instruction-messages"]}
              >
                <div className="d-flex align-items-center gap-2 mb-3">
                  <ToggleSwitch
                    label="bill-me-later-toggle"
                    customClass={"mt-2 ml-0 mb-2"}
                    value={!!acknowledgementToggleOn}
                    onChange={() => handleEnablePolicyAcknowledgement()}
                  />
                  <Text
                    size="14px"
                    weight="600"
                    color="#2F3245"
                    className="mb-0 text-capitalize"
                  >
                    {t("accountPreferences.policyAcknowledgeByStaff.allow")}
                  </Text>
                </div>
              </div>
              <div
                className={`${
                  !acknowledgementToggleOn ? "custom-disabled-field" : ""
                }`}
              >
                <div className="pb-3 mb-3 border-bottom-grey">
                  <Text size="13px" weight="400" color="#79869A">
                    Acknowledgement Statement
                  </Text>
                  <Text weight="600" color="#79869A">
                    {
                      "I, <First Name/Last Name>, acknowledge that I have received, read, and understood <Policy Name>."
                    }
                  </Text>
                </div>
                <div className="c-field">
                  <textarea
                    className="c-form-control"
                    Placeholder={t("officePolicyManagement.enterDescription")}
                    name="Summary"
                    rows={7}
                    value={states.Summary}
                    onChange={handleOnChange}
                  ></textarea>
                  {errors.Summary && (
                    <span className="error-msg">{errors.Summary}</span>
                  )}
                </div>

                <div className={accountPrefrencesStyles["approver-section"]}>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <ToggleSwitch
                      label="approver-toggle"
                      customClass={"mt-2 ml-0 mb-2"}
                      value={!!approverToggleOn}
                      onChange={() => setApproverToggleOn(!approverToggleOn)}
                    />
                    <Text
                      size="14px"
                      weight="600"
                      color="#2F3245"
                      className="mb-0 text-capitalize"
                    >
                      {t(
                        "accountPreferences.policyAcknowledgeByStaff.approver"
                      )}
                    </Text>
                  </div>
                  {approverToggleOn && (
                    <>
                      {approvers.map((approver, index) => (
                        <div
                          key={approver.id}
                          className={accountPrefrencesStyles["approver-card"]}
                        >
                          {approver.isDefault && (
                            <div
                              className={
                                accountPrefrencesStyles["default-badge"]
                              }
                            >
                              {t("superAdmin.default")}
                            </div>
                          )}
                          <div
                            className={
                              accountPrefrencesStyles["approver-content"]
                            }
                          >
                            <div
                              className={
                                accountPrefrencesStyles["selection-method"]
                              }
                            >
                              <div className="ch-radio d-flex">
                                <label
                                  className="mr-5"
                                  onClick={() =>
                                    updateApprover(approver.id, {
                                      selectionMethod: "staff",
                                    })
                                  }
                                >
                                  <input
                                    type="radio"
                                    name={`selectionMethod-${approver.id}`}
                                    checked={
                                      approver.selectionMethod === "staff"
                                    }
                                    onChange={() => {}}
                                  />
                                  <span>
                                    {t(
                                      "accountPreferences.policyAcknowledgeByStaff.selectStaffList"
                                    )}
                                  </span>
                                </label>
                                <label
                                  className="mr-5"
                                  onClick={() =>
                                    updateApprover(approver.id, {
                                      selectionMethod: "manual",
                                    })
                                  }
                                >
                                  <input
                                    type="radio"
                                    name={`selectionMethod-${approver.id}`}
                                    checked={
                                      approver.selectionMethod === "manual"
                                    }
                                    onChange={() => {}}
                                  />
                                  <span>
                                    {t(
                                      "accountPreferences.policyAcknowledgeByStaff.addManually"
                                    )}
                                  </span>
                                </label>
                              </div>
                            </div>

                            {approver.selectionMethod === "staff" ? (
                              <div
                                className={
                                  accountPrefrencesStyles["staff-selection"]
                                }
                              >
                                <div className="c-field">
                                  <label>{t("notices.selectStaff")}</label>
                                  <div
                                    className={
                                      accountPrefrencesStyles[
                                        "selected-staff-display"
                                      ]
                                    }
                                  >
                                    <Text weight="600" color="#2F3245">
                                      {approver.staffId
                                        ? (() => {
                                            const staff = staffList?.find(
                                              (s) => s.id === approver.staffId
                                            );
                                            return staff
                                              ? `${staff.firstName} ${staff.lastName}`
                                              : `${t("notices.selectStaff")}`;
                                          })()
                                        : `${t("notices.selectStaff")}`}
                                    </Text>
                                    <span
                                      className="link-btn"
                                      onClick={() => {
                                        openStaffSelectionModal(approver.id);
                                      }}
                                    >
                                      {t("notices.select")}
                                    </span>
                                  </div>
                                  {approverErrors[approver.id]?.staff && (
                                    <span className="error-msg">
                                      {approverErrors[approver.id].staff}
                                    </span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div
                                className={
                                  accountPrefrencesStyles["manual-entry"]
                                }
                              >
                                <div className="c-field">
                                  <Input
                                    Title={t("waitingList.name")}
                                    Type="text"
                                    Placeholder={t("form.placeholder1", {
                                      field: "",
                                    })}
                                    Name={"Name"}
                                    Value={approver.name}
                                    HandleChange={(e) =>
                                      updateApprover(approver.id, {
                                        name: e.target.value,
                                      })
                                    }
                                    MaxLength="100"
                                    Error={
                                      approverErrors[approver.id]?.name || ""
                                    }
                                  />
                                </div>
                              </div>
                            )}

                            <div className="c-field">
                              <Input
                                Title="Title"
                                Type="text"
                                Placeholder={t("form.placeholder1", {
                                  field: "",
                                })}
                                Name={"Title"}
                                Value={approver.title}
                                HandleChange={(e) =>
                                  updateApprover(approver.id, {
                                    title: e.target.value,
                                  })
                                }
                                MaxLength="200"
                                Error={approverErrors[approver.id]?.title || ""}
                              />
                            </div>

                            <div
                              className={
                                accountPrefrencesStyles["approver-actions"]
                              }
                            >
                              <button
                                type="button"
                                className={
                                  accountPrefrencesStyles["mark-default-btn"]
                                }
                                disabled={approver?.isDefault}
                                onClick={() => markAsDefault(approver.id)}
                              >
                                <img
                                  src={starOutlineIcon}
                                  alt="starOutlineIcon"
                                  id="TooltipRatingsBtn"
                                />
                                {t("accountOwner.markAsDefault")}
                              </button>
                              {approvers.length > 1 && (
                                <button
                                  type="button"
                                  className={
                                    accountPrefrencesStyles["delete-btn"]
                                  }
                                  onClick={() => deleteApprover(approver?.id)}
                                >
                                  <img
                                    src={deleteIcon}
                                    alt="deleteIcon"
                                    id="TooltipRatingsBtn"
                                  />
                                  {t("delete")}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                      {approvers.length < 10 && (
                        <button
                          type="button"
                          className={
                            accountPrefrencesStyles["add-approver-btn"]
                          }
                          onClick={addApprover}
                        >
                          <img
                            src={addIcon}
                            alt="addIcon"
                            id="TooltipRatingsBtn"
                          />
                          {t(
                            "accountPreferences.policyAcknowledgeByStaff.addAnotherApprover"
                          )}
                        </button>
                      )}
                      {errors.approvers && (
                        <div className="error-msg mt-2">{errors.approvers}</div>
                      )}
                    </>
                  )}
                </div>
                <div
                  className={
                    accountPrefrencesStyles["new-instruction-messages"]
                  }
                ></div>
                <div className={styles["btn_wrapper"]}>
                  <button
                    className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
                    title="save"
                    type="submit"
                  >
                    {t("save")}
                  </button>
                  <button
                    className="mb-md-3 button button-round button-border btn-mobile-link button-dark"
                    title="cancel"
                    onClick={goBack}
                    type="button"
                  >
                    {t("officePolicyManagement.cancel")}
                  </button>
                </div>
              </div>
            </Card>
          </form>
        </>
      ) : (
        <div
          className="not-accessible center_property"
          style={{ height: "300px" }}
        >
          <NotAccessible Message={t("dashBoard.notAccessible")} />
        </div>
      )}
      {showStaffSelectionModal && (
        <SelectApprover
          isOpen={showStaffSelectionModal}
          closeModal={setShowStaffSelectionModal}
          staffList={staffList}
          handleStaffSelection={handleStaffSelection}
          existingApprovers={approvers}
          ownerId={states?.OwnerId}
          selectedApprover={(() => {
            const currentApprover = approvers.find(
              (approver) => approver.id === currentApproverId
            );
            if (currentApprover?.staffId) {
              return staffList?.find(
                (staff) => staff.id === currentApprover.staffId
              );
            }
            // Handle manual approvers - find matching staff member by name
            if (
              currentApprover?.selectionMethod === "manual" &&
              currentApprover?.name &&
              staffList?.length
            ) {
              const approverName = currentApprover.name?.trim().toLowerCase();
              // Remove any title in parentheses if present (e.g., "Fdfdsfsd (Ffdsf)" -> "Fdfdsfsd")
              const approverNameWithoutTitle = approverName
                .replace(/\s*\([^)]*\)$/, "")
                .trim();

              const matchingStaff = staffList.find((staff) => {
                const staffFullName = `${staff.firstName || ""} ${
                  staff.lastName || ""
                }`
                  .trim()
                  .toLowerCase();
                const staffFirstName = (staff.firstName || "")
                  .trim()
                  .toLowerCase();

                // Try multiple matching strategies:
                // 1. Exact match with full name
                // 2. Match against name without title
                // 3. Match against firstName only
                return (
                  staffFullName === approverName ||
                  staffFullName === approverNameWithoutTitle ||
                  staffFirstName === approverName ||
                  staffFirstName === approverNameWithoutTitle
                );
              });
              return matchingStaff || null;
            }
            return null;
          })()}
        />
      )}
      {confirmDeleteModal && (
        <DeleteConfirmationModal
          closeDeleteModal={cancelDeleteApprover}
          confirmDelete={confirmDeleteApprover}
          confirmDeleteMessage={confirmDeleteApprover}
          deleteMessage={t(
            "accountPreferences.policyAcknowledgeByStaff.deleteMessage"
          )}
          title={t(
            "accountPreferences.policyAcknowledgeByStaff.deleteModalTitle"
          )}
          btnText={t("delete")}
        />
      )}
    </Page>
  );
};

export default withTranslation()(PolicyAcknowledgementTemplate);
